import React from "react";
import { Tabs } from "./recruitmentAgents.types";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const RecruitmentAgents: React.FC = () => {
  const { pathname } = useLocation();
  console.log(pathname, "pathname");

  const activeTab = pathname
    ?.toLowerCase()
    ?.replace("/recruitment-agents/", "");
  const navigate = useNavigate();

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-6">
      <div className="flex gap-10 border-b w-[100%] py-2">
        <button
          className={`text-[#BABABA] leading-5 text-xs  border-b  ${
            activeTab ===
              Tabs.PartnerAgencies?.replaceAll(" ", "-")?.toLowerCase() ||
            activeTab === "/recruitment-agents"
              ? "border-b-primary font-medium text-primary"
              : "border-b-white font-normal"
          }`}
          onClick={() => navigate(`/recruitment-agents`)}
        >
          {Tabs?.PartnerAgencies}
        </button>
        <button
          className={`text-[#BABABA]  leading-5 text-xs border-b ${
            activeTab ===
            Tabs.SearchRecruitmentAgencies?.replaceAll(" ", "-")?.toLowerCase()
              ? "border-b-primary font-medium text-primary"
              : "border-b-white font-normal"
          }`}
          onClick={() =>
            navigate(
              `/recruitment-agents/${Tabs.SearchRecruitmentAgencies?.replaceAll(
                " ",
                "-"
              )?.toLowerCase()}`
            )
          }
        >
          {Tabs?.SearchRecruitmentAgencies}
        </button>
      </div>
      <Outlet />
    </div>
  );
};

export default RecruitmentAgents;
